<div class="layout-footer">
    <div class="footer-start">
        <img [src]="'assets/layout/images/logogim.png'" alt="logo" />
        <span class="app-name">Gimnasia</span>
    </div>
    <div class="footer-end">
        <span>© Alberto Jimenez & Jegerima</span>
    </div>
</div>
